export const assignABVariant = () => {
    const existing = localStorage.getItem('ab_variant');
    if (existing) return existing;

    // Show the option of appointment booking in returning intake
    //     const variant = Math.random() < 0.5 ? 'show_appt_booking_in_ret_intake' : 'hide_appt_booking_in_ret_intake';

    // hiding the appointment booking screen in returning intake
    const variant = 'hide_appt_booking_in_ret_intake';
    localStorage.setItem('ab_variant', variant);
    return variant;
};

